export interface CatalogItem {
  id: string;
  name: string;
  color: string;
  order?: number;
  archived?: boolean;
}

/** Preserves the label chosen by the user while preventing superficial duplicates. */
export function normalizeCatalogName(value: string) {
  return value.trim().replace(/\s+/g, " ").toLocaleLowerCase();
}

export function uniqueCatalogIds(ids: string[]) {
  return [...new Set(ids.filter(Boolean))];
}
